import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  inject,
  input,
  Input,
  OnDestroy,
  Output,
  ViewChild,
} from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AddressLookupFormFieldComponent, ButtonFormFieldComponent } from 'form-field';
import { LineCheckInstallationAddress } from 'interfaces';
import { LineCheckProductsService } from 'line-check-products';
import { AddressLookupFields } from 'utils';

@Component({
  selector: 'lib-line-check-form',
  templateUrl: './line-check-form.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [FormsModule, ReactiveFormsModule, AddressLookupFormFieldComponent, ButtonFormFieldComponent],
})
export class LineCheckFormComponent implements OnDestroy {
  private lineCheckProductsService = inject(LineCheckProductsService);
  @Input() addressLookupFields: AddressLookupFields;
  @Input() buttonText: string;
  @Input() backButtonText: string;
  lineCheckResultsShown = input<boolean>();
  lineCheckResultsLoading = input<boolean>();
  @Input() addressPrefill: LineCheckInstallationAddress | null;
  @Output() addressFormSubmitEvent = new EventEmitter<LineCheckInstallationAddress>();
  @Output() addressFormReset = new EventEmitter<void>();
  @ViewChild('submitButton') submitButton: ButtonFormFieldComponent;

  ngOnDestroy() {
    this.lineCheckProductsService.lineCheckResultsShown$.next(false);
  }

  postCode: string;
  city: string;
  streetName: string;
  streetNumber: string;

  getPostCodeValue(value: string) {
    this.postCode = value;
  }

  getCityValue(value: string) {
    this.city = value;
  }

  getStreetValue(value: string) {
    this.streetName = value;
  }

  getStreetNumberValue(value: string) {
    this.streetNumber = value === 'NA' ? '' : value;
    if (this.city && this.streetName && this.streetNumber) this.submitButton?.focus();
  }

  onReset() {
    this.lineCheckProductsService.lineCheckResultsShown$.next(false);
    this.addressFormReset.emit();
  }

  onSubmit() {
    this.addressFormSubmitEvent.emit({
      postCode: this.postCode,
      city: this.city,
      streetName: this.streetName,
      streetNumber: this.streetNumber,
    });
  }
}
